import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: 'Sarah Mitchell',
    role: 'Managing Director',
    text: "We've relied on Binary Consultancy for over five years now. They handle everything from our server monitoring to our mobile contracts, and they're always just a phone call away. Genuinely brilliant support.",
    stars: 5,
  },
  {
    name: 'James Hargreaves',
    role: 'Operations Manager',
    text: "When we had a ransomware scare, Binary Consultancy had us back up and running within hours. Their Huntress cyber security setup has given us real peace of mind. Can't recommend them enough.",
    stars: 5,
  },
  {
    name: 'Rachel Thornton',
    role: 'Office Manager',
    text: "Switching our phone system to Gamma Horizon through Binary Consultancy was the best decision we made. The team handled the entire migration without any downtime. Professional from start to finish.",
    stars: 5,
  },
  {
    name: 'David Lees',
    role: 'Company Director',
    text: "As a small business in Glossop, it's great to have a local IT partner who actually understands our needs. They set up our Microsoft 365 and network infrastructure, and the ongoing support is second to none.",
    stars: 5,
  },
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-200 rounded-full text-blue-700 text-sm font-medium mb-5">
            <Star className="w-4 h-4 fill-blue-600" />
            Client Testimonials
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Trusted Across the Northwest
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            From Glossop to Manchester, businesses across the Northwest rely on us for their IT and telecoms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="relative bg-white border border-slate-200 rounded-2xl p-8 hover:shadow-lg hover:border-blue-200 transition-all duration-300"
              data-testid={`testimonial-card-${t.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-blue-100" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.stars }).map((_, j) => (
                  <Star key={`star-${j}`} className="w-4 h-4 text-amber-400 fill-amber-400" />
                ))}
              </div>
              <p className="text-slate-600 leading-relaxed mb-6 text-[15px]">"{t.text}"</p>
              <div>
                <p className="font-semibold text-slate-900">{t.name}</p>
                <p className="text-sm text-slate-500">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
